import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'x-card',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './x-card.component.html',
  styleUrl: './x-card.component.scss',
})
export class XCardComponent {}
